// extracted by mini-css-extract-plugin
export default {"tab-header":"MyPageMain_tab-header__4HZNb","my-data-box":"MyPageMain_my-data-box__dtvYh"};